import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../api";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email.trim(), password);
      toast.success(`Welcome back, ${user.name}`);
      const from = location.state?.from;
      if (user.role === "admin") navigate(from && from.startsWith("/admin") ? from : "/admin/orders", { replace: true });
      else navigate(from || "/account", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[78vh] flex items-center justify-center px-6 py-16">
      <form onSubmit={submit} className="w-full max-w-md bg-[#141210] border border-[#2c2822] rounded-2xl p-8 md:p-10" data-testid="login-form">
        <p className="text-[#c9a24b] text-xs tracking-[0.3em] uppercase text-center mb-3">Welcome back</p>
        <h1 className="font-display text-3xl text-[#f4efe4] text-center mb-8">Sign In</h1>

        <label className="block text-[#a29a8c] text-xs tracking-[0.12em] uppercase mb-2">Email</label>
        <div className="relative mb-5">
          <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6b6459]" />
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
            className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md pl-11 pr-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors" placeholder="you@email.com" />
        </div>

        <label className="block text-[#a29a8c] text-xs tracking-[0.12em] uppercase mb-2">Password</label>
        <div className="relative mb-6">
          <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6b6459]" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
            className="w-full bg-[#0b0a09] border border-[#2c2822] rounded-md pl-11 pr-4 py-3 text-[#f4efe4] outline-none focus:border-[#c9a24b] transition-colors" placeholder="••••••••" />
        </div>

        {error && <p className="text-red-400 text-sm mb-5" data-testid="login-error">{error}</p>}

        <button type="submit" disabled={loading} data-testid="login-submit"
          className="btn-gold w-full py-3.5 rounded-full text-sm tracking-[0.2em] uppercase font-medium disabled:opacity-60">
          {loading ? "Signing in…" : "Sign In"}
        </button>

        <p className="text-[#a29a8c] text-sm text-center mt-6">
          New here?{" "}
          <Link to="/register" className="text-[#c9a24b] hover:underline" data-testid="go-register">Create an account</Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
